import { Injectable, Injector } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpDataService } from './http-data.service';
import { Observable } from 'rxjs';

@Injectable()
export class SecurityService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/security');
  }

  public validateClientJwtToken(token: string): Observable<any> {
    const url = `${this.baseUrl}/tokens/client-jwt/${token}`;
    return this.http.get(url).pipe(
      map((resp) => resp),
      catchError((error) => this.handleObservableError(error))
    );
  }

  /**
   * Reset the user password with the user email
   * @param userEmail
   */
  public resetUserPassword(userEmail: string): Promise<any> {
    return super.putRequest(
      `${this.baseUrl}/security-users/reset-user-password`,
      { username: userEmail },
      this.getRequestOptions()
    );
  }
}
